var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "url(#a)",
          d:
            "M13.833 8c.46 0 .839-.375.781-.831a6.666 6.666 0 1 0-7.446 7.446c.457.057.832-.322.832-.782s-.376-.826-.83-.902a5 5 0 1 1 5.76-5.76c.077.453.443.829.903.829Z"
        }
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "a",
                x1: ".331",
                x2: "15.669",
                y1: "1.333",
                y2: "14.667",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                attrs: { offset: ".022", "stop-color": "#DEA5FA" }
              }),
              _c("stop", { attrs: { offset: ".97", "stop-color": "#733FE0" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }